import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimes, faChevronDown, faSearch } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FlyerService, UpdateFlyerDto } from '@clooper/core';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { AIRLINES, Airline } from '../data/airlines.data';
import { flyerNumberValidator } from '../../shared/validators/id-document.validators';

@Component({
  selector: 'app-edit-flyer-info-modal',
  templateUrl: './edit-flyer-info-modal.component.html',
  styleUrls: ['./edit-flyer-info-modal.component.scss']
})
export class EditFlyerInfoModalComponent implements OnInit {
  icons = { close: faTimes, chevronDown: faChevronDown, search: faSearch };
  flyerForm: FormGroup;

  // Set via initialState
  _id: string;
  flyer_number: string;
  airline: string;
  onEdited: () => void;

  airlines: Airline[] = AIRLINES;
  filteredAirlines: Airline[] = AIRLINES;
  airlineSearch = '';
  showAirlineDropdown = false;
  selectedAirline: Airline | null = null;
  isSubmitting = false;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private elRef: ElementRef,
    private flyerService: FlyerService
  ) {}

  ngOnInit(): void {
    this.flyerForm = this.fb.group({
      flyer_number: [this.flyer_number || '', [Validators.required, flyerNumberValidator]],
      airline: [this.airline || '', Validators.required],
    });

    // Pre-select airline if editing
    if (this.airline) {
      this.selectedAirline = this.airlines.find(a => a.name === this.airline) || null;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elRef.nativeElement.querySelector('.airline-dropdown-wrapper')?.contains(event.target)) {
      this.showAirlineDropdown = false;
    }
  }

  toggleDropdown(): void {
    this.showAirlineDropdown = !this.showAirlineDropdown;
    if (this.showAirlineDropdown) {
      this.airlineSearch = '';
      this.filteredAirlines = this.airlines;
    }
  }

  filterAirlines(): void {
    const term = this.airlineSearch.toLowerCase();
    this.filteredAirlines = this.airlines.filter(
      a => a.name.toLowerCase().includes(term) || a.iata_code.toLowerCase().includes(term)
    );
  }

  selectAirline(airline: Airline): void {
    this.selectedAirline = airline;
    this.flyerForm.get('airline')?.setValue(airline.name);
    this.showAirlineDropdown = false;
  }

  close(): void {
    this.bsModalRef?.hide();
  }

  saveChanges(): void {
    if (this.flyerForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const updates: UpdateFlyerDto = {
        flyer_number: this.flyerForm.value.flyer_number,
        airline: this.selectedAirline?.iata_code || this.flyerForm.value.airline,
        airline_name: this.selectedAirline?.name || this.flyerForm.value.airline
      };
      this.flyerService.updateFlyerFullResponse(this._id, updates).subscribe({
        next: () => {
          this.isSubmitting = false;
          if (this.onEdited) this.onEdited();
          this.close();
          this.modalService.show(SuccessModalComponent, {
            initialState: {
              title: 'Flyer Info Updated!',
              subtitle: 'Your frequent flyer information has been updated successfully.'
            },
            class: 'modal-rounded'
          });
        },
        error: () => {
          this.isSubmitting = false;
        }
      });
    }
  }
}
